function taxInitializer() {
  // 2022 tax rates provided by David

  const fedTaxRates = [
    { max: 14398, tax: 0 },
    { max: 50197, tax: 0.15 },
    { max: 100392, tax: 0.205 },
    { max: 155625, tax: 0.26 },
    { max: 221708, tax: 0.2938 },
    { max: Number.MAX_VALUE, tax: 0.33 },
  ];

  const provTaxRates = {
    AB: [
      { max: 19814, tax: 0 },
      { max: 134238, tax: 0.1 },
      { max: 161086, tax: 0.12 },
      { max: 214781, tax: 0.13 },
      { max: 322171, tax: 0.14 },
      { max: Number.MAX_VALUE, tax: 0.15 },
    ],
    BC: [
      { max: 11302, tax: 0 },
      { max: 43070, tax: 0.0506 },
      { max: 86141, tax: 0.0770 },
      { max: 98901, tax: 0.105 },
      { max: 120094, tax: 0.1229 },
      { max: 162832, tax: 0.1470 },
      { max: 227091, tax: 0.1680 },
      { max: Number.MAX_VALUE, tax: 0.2050 },
    ],
    MB: [
      { max: 10145, tax: 0 },
      { max: 34431, tax: 0.108 },
      { max: 74416, tax: 0.1275 },
      { max: Number.MAX_VALUE, tax: 0.1740 },
    ],
    NB: [
      { max: 11720, tax: 0 },
      { max: 44887, tax: 0.094 },
      { max: 89775, tax: 0.1482 },
      { max: 145955, tax: 0.1652 },
      { max: 166280, tax: 0.1784 },
      { max: Number.MAX_VALUE, tax: 0.203 },
    ],
    NL: [
      { max: 9804, tax: 0 },
      { max: 39147, tax: 0.087 },
      { max: 78294, tax: 0.145 },
      { max: 139780, tax: 0.158 },
      { max: 195693, tax: 0.178 },
      { max: 250000, tax: 0.198 },
      { max: 500000, tax: 0.208 },
      { max: 1000000, tax: 0.213 },
      { max: Number.MAX_VALUE, tax: 0.218 },
    ],
    NT: [
      { max: 15609, tax: 0 },
      { max: 45462, tax: 0.059 },
      { max: 90927, tax: 0.086 },
      { max: 147826, tax: 0.122 },
      { max: Number.MAX_VALUE, tax: 0.1405 },
    ],
    NS: [
      { max: 8481, tax: 0 },
      { max: 29590, tax: 0.0879 },
      { max: 59180, tax: 0.1495 },
      { max: 93000, tax: 0.1667 },
      { max: 150000, tax: 0.175 },
      { max: Number.MAX_VALUE, tax: 0.21 },
    ],
    NU: [
      { max: 16862, tax: 0 },
      { max: 47862, tax: 0.04 },
      { max: 95724, tax: 0.07 },
      { max: 155625, tax: 0.09 },
      { max: Number.MAX_VALUE, tax: 0.115 },
    ],
    ON: [
      { max: 11141, tax: 0 },
      { max: 46226, tax: 0.0505 },
      { max: 92454, tax: 0.0915 },
      { max: 150000, tax: 0.1116 },
      { max: 220000, tax: 0.1216 },
      { max: Number.MAX_VALUE, tax: 0.1316 },
    ],
    PE: [
      { max: 11250, tax: 0 },
      { max: 31984, tax: 0.098 },
      { max: 63969, tax: 0.138 },
      { max: Number.MAX_VALUE, tax: 0.167 },
    ],
    QC: [
      { max: 16143, tax: 0 },
      { max: 46295, tax: 0.15 },
      { max: 92580, tax: 0.2 },
      { max: 112655, tax: 0.24 },
      { max: Number.MAX_VALUE, tax: 0.2575 },
    ],
    SK: [
      { max: 16615, tax: 0 },
      { max: 46773, tax: 0.105 },
      { max: 133638, tax: 0.125 },
      { max: Number.MAX_VALUE, tax: 0.145 },
    ],
    YT: [
      { max: 14398, tax: 0 },
      { max: 50197, tax: 0.064 },
      { max: 100392, tax: 0.09 },
      { max: 155625, tax: 0.109 },
      { max: 221708, tax: 0.1296 },
      { max: 500000, tax: 0.128 },
      { max: Number.MAX_VALUE, tax: 0.15 },
    ],
  };

  const noProvinceError = 'TaxService: No province specified.';

  return {
    getTaxTable(grossIncome, brackets) {
      let min = 0;
      const results = [];
      _.forEach(brackets, (bracket) => {
        let taxAmount;

        if (grossIncome < min) {
          return false;
        }

        if (grossIncome <= bracket.max) {
          taxAmount = Math.max(grossIncome - min, 0) * bracket.tax;
        } else {
          taxAmount = (bracket.max - min) * bracket.tax;
        }

        const max = bracket.max === Number.MAX_VALUE ? null : bracket.max;
        const result = {
          max,
          min,
          rate: bracket.tax,
          amount: taxAmount,
        };

        results.push(result);
        min = bracket.max;

        return true;
      });

      return results;
    },
    getFederalTaxTable(grossIncome) {
      return this.getTaxTable(grossIncome || 0, fedTaxRates);
    },
    getProvincialTaxTable(grossIncome, province) {
      if (province) {
        const brackets = provTaxRates[province];
        return this.getTaxTable(grossIncome, brackets);
      }
      throw noProvinceError;
    },
    getFederalTaxAmount(grossIncome) {
      return _.sumBy(this.getFederalTaxTable(grossIncome), 'amount');
    },
    getProvTaxAmount(grossIncome, province) {
      return _.sumBy(this.getProvincialTaxTable(grossIncome, province), 'amount');
    },
    getNetIncome(grossIncome, province) {
      return grossIncome - this.getTaxes(grossIncome, province);
    },
    getTaxes(grossIncome, province) {
      const fedTaxAmount = this.getFederalTaxAmount(grossIncome);
      const provTaxAmount = this.getProvTaxAmount(grossIncome, province);
      return fedTaxAmount + provTaxAmount;
    },
    getAverageTaxRate(grossIncome, province) {
      if (grossIncome === 0) {
        return 0;
      } else if (!grossIncome) {
        return undefined;
      }

      const fedTaxAmount = this.getFederalTaxAmount(grossIncome);
      const provTaxAmount = this.getProvTaxAmount(grossIncome, province);
      return (fedTaxAmount + provTaxAmount) / grossIncome;
    },
    getMarginalTaxRate(grossIncome, province) {
      if (province) {
        if (grossIncome === null) {
          return undefined;
        }

        const { tax: fedMarginalTR } = _.find(fedTaxRates, bracket => grossIncome <= bracket.max);

        const taxRatesForProvince = provTaxRates[province];
        const provMarginalTR = taxRatesForProvince ?
          _.find(taxRatesForProvince, bracket => grossIncome <= bracket.max)
            .tax
          : 0;

        return provMarginalTR + fedMarginalTR;
      }
      throw noProvinceError;
    },
    getFederalTaxRates() {
      return angular.copy(fedTaxRates);
    },
    getProvincialTaxRates(province) {
      if (province != null) { return angular.copy(provTaxRates[province]); }
      return angular.copy(provTaxRates);
    },
    getGrossIncomeFromNet(netIncome, province) {
      if (province) {
        const values = _(fedTaxRates)
          .union(provTaxRates[province])
          .map(({ max }) => max)
          .uniq()
          .sortBy()
          .value();

        let taxPaid = 0;
        let lastNetValue = 0;
        let bracketRate;

        _.forEach(values, (value) => {
          const netValue = this.getNetIncome(value, province);
          if (netValue <= netIncome) {
            taxPaid = value - netValue;
            lastNetValue = netValue;
            return true;
          }

          bracketRate = this.getMarginalTaxRate(value, province);
          return false;
        });

        return lastNetValue + taxPaid + ((netIncome - lastNetValue) / (1 - bracketRate));
      }

      throw noProvinceError;
    },
    getTaxDeduction(grossIncome, deduction, province) {
      const before = this.getTaxes(grossIncome, province);
      const after = this.getTaxes(grossIncome - deduction, province);
      return before - after;
    },
  };
}

angular.module('wbServices').service('tax', [taxInitializer]);

export default taxInitializer;
